import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { FormSection } from 'redux-form';
import { propArrayShape, propBool, propShape, } from '../../../../../helpers/custom-prop-types';
import PlainInputComponent from '../../../../Ui/Common/PlainInputComponent';
const ExperienceClassPartsOther = (props) => {
    const { experienceClasses, input, isDisabled, meta } = props;
    const experienceClassesOther = useMemo(() => experienceClasses.find(({ isOther }) => isOther) || {}, [experienceClasses]);
    return (_jsx("div", { children: _jsx(FormSection, Object.assign({ name: `experienceClasses.${experienceClassesOther.id}` }, { children: _jsx(PlainInputComponent, { className: 'input-form-text asign-state', disabled: isDisabled, input: input, meta: meta, placeholder: 'その他（10文字以内で記載ください）' }) })) }));
};
ExperienceClassPartsOther.propTypes = {
    experienceClasses: propArrayShape().isRequired,
    input: propShape().isRequired,
    isDisabled: propBool().isRequired,
    meta: propShape().isRequired,
};
export default ExperienceClassPartsOther;
